import React, { useState, useEffect } from "react";
import { Form, Col } from "react-bootstrap";
import { withCookies } from "react-cookie";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState } from "draft-js";
import configVars from "../../config";
import { useTranslation } from "react-i18next";

const Evaluation = ({ selectedTask, config }) => {
  const allTaskStatus = config && config["task_status"];
  const [title, setTitle] = useState({
    value: "",
    error: false,
  });
  const [result, setResult] = useState("");
  const [impact, setImpact] = useState("");
  const [status, setStatus] = useState("");
  const [translation] = useTranslation("translations");

  useEffect(() => {
    if (selectedTask) {
      setTitle({ value: selectedTask.title, error: false });

      let evaluation_impact = selectedTask?.evaluation_impact;

      if (evaluation_impact) {
        const contentBlock1 = htmlToDraft(evaluation_impact);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setImpact(editorState);
        }
      }

      let evaluation_result = null;
      if (selectedTask?.action_plan_decided_action) {
        evaluation_result = selectedTask?.action_plan_decided_action;
      } else if (selectedTask?.idea_for_change_description) {
        evaluation_result = selectedTask?.idea_for_change_description;
      } else if (selectedTask?.implementation_decided_action) {
        evaluation_result = selectedTask?.implementation_decided_action;
      } else if (selectedTask?.evaluation_result) {
        evaluation_result = selectedTask?.evaluation_result;
      }

      if (evaluation_result) {
        const contentBlock1 = htmlToDraft(evaluation_result);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setResult(editorState);
        }
      }
      setStatus(selectedTask?.task_status?.term_id);
    }
  }, [selectedTask]);

  return (
    <Form>
      <div className="">
        <Col className="">
          <div className="d-lg-flex flex-lg-column">
            <Form.Group className="mb-3">
              <Form.Label>
                <b> {translation("title")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={translation("task_forms.idea_bank.placeholder")}
                value={title?.value}
                disabled
                isInvalid={title?.error}
                style={{ fontSize: "14px", padding: "0.5rem 0.5rem" }}
              />
              {title?.error && (
                <Form.Control.Feedback type="invalid">
                  {translation("title_empty_warning")}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </div>
        </Col>
      </div>

      <div className="d-flex mt-2">
        <Form.Label>
          <b> {translation("status")}</b>{" "}
        </Form.Label>
      </div>
      <div className="d-flex">
        {config &&
          allTaskStatus &&
          Object.keys(allTaskStatus)?.map((item, index) => {
            return (
              <button
                key={index}
                style={{
                  height: "32px",
                  width: "90px",
                  padding: "0px 0px",
                  fontSize: "13px",
                  borderRadius: "32px",
                  marginRight: "10px",
                }}
                type="button"
                className={` btn border-1 ${
                  status === allTaskStatus[item].term_id
                    ? `btn-sy-${allTaskStatus[item].slug} text-white`
                    : `btn-outline-sy-${allTaskStatus[item]?.slug}`
                }`}
                disabled
              >
                {allTaskStatus[item]?.name}
              </button>
            );
          })}
      </div>

      <Form.Group className="mb-3 mt-3">
        <Form.Label>
          <b> {translation("result")}</b>{" "}
        </Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          toolbarOnFocus
          editorState={result}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>{translation("impact")}</Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          toolbarOnFocus
          editorState={impact}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
    </Form>
  );
};

export default withCookies(Evaluation);
